"use client";

import { useSession } from "next-auth/react";

/**
 * Presentational read of the signed-in identity. Wraps `useSession()` so the
 * shell/components depend on a small domain shape rather than NextAuth's
 * session object directly.
 */
export interface CurrentUser {
  userId: string;
  username: string;
  usertype: string;
  isAdmin: boolean;
}

export interface UseCurrentUser {
  user: CurrentUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export function useCurrentUser(): UseCurrentUser {
  const { data, status } = useSession();

  const sessionUser = data?.user;
  const user: CurrentUser | null = sessionUser
    ? {
        userId: sessionUser.user_id,
        username: sessionUser.username,
        usertype: sessionUser.usertype,
        isAdmin: sessionUser.usertype === "admin",
      }
    : null;

  return {
    user,
    isAuthenticated: status === "authenticated",
    isLoading: status === "loading",
  };
}
